import { UserPlus, Package, Users, Wallet } from "lucide-react";

const STEPS = [
  { icon: UserPlus, title: "Register free", desc: "Fill a 60-second form. We call you within 24 hours to onboard." },
  { icon: Package, title: "Get starter kit", desc: "Receive assorted home care products at wholesale rates." },
  { icon: Users, title: "Sell in your circle", desc: "Neighbours, WhatsApp groups, resident welfare — build your customer base." },
  { icon: Wallet, title: "Earn ₹5k–10k / month", desc: "Keep the margin. Reorder anytime. Grow at your own pace." },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-section" className="section-pad bg-white border-y border-[#E7E5E4]">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C]">Process</div>
          <h2 className="font-display mt-3 text-3xl sm:text-5xl font-black text-[#064E3B] tracking-tight">
            Four steps to your first paycheck
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#44403C]">
            No prior sales experience needed. Anyone at home — homemakers, students, retirees — can start.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.title}
              data-testid={`step-${i + 1}`}
              className="card-lift bg-[#FAFAF9] border border-[#E7E5E4] rounded-2xl p-7"
            >
              <div className="flex items-center justify-between">
                <div className="h-12 w-12 rounded-xl bg-[#064E3B] flex items-center justify-center">
                  <s.icon className="h-6 w-6 text-[#F59E0B]" />
                </div>
                <span className="font-display text-4xl font-black text-[#E7E5E4]">0{i + 1}</span>
              </div>
              <h3 className="mt-5 font-display font-bold text-xl text-[#064E3B]">{s.title}</h3>
              <p className="mt-2 text-sm text-[#57534E] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
